// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__8C8O-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1AC0c"};